<div class="filter-option">
  <div class="form-check">
    <input class="form-check-input" type="checkbox" [id]="eventFilter.parentOption.primaryKey" [(ngModel)]="eventFilter.parentOption.isSelected" (change)="selectUnSelectAll()">
    <label class="form-check-label" [for]="eventFilter.parentOption.primaryKey">
      {{eventFilter.parentOption.displayName}}
    </label>
  </div>
</div>
<ul class="filter-list-item">
  @for (filterOption of eventFilter.fnFilterOptionArray; track filterOption) {
    <li>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [id]="filterOption.primaryKey" [(ngModel)]="filterOption.isSelected" (change)="selectUnselectOption(eventFilter,filterOption)">
        <label class="form-check-label" [for]="filterOption.primaryKey">
          {{filterOption.displayName}}
        </label>
      </div>
    </li>
  }
</ul>